// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609021926/js/" + chunkId + "." + {"44":"053f5860","225":"46e000d0","481":"34b2defa","486":"a15161bf","770":"a2b7af72"}[chunkId] + ".0.7401306042868337.chunk.js";
};